export default class Tag{
    id;
    name;
    constructor(data){
        this.id=data.id;
        this.name=data.name;
    }
}